// named as generic since it can be used for links in the user header as well
// handles things like sign in, register, subscribe link clicks
// relative paths come from the configData retrieved from the experience endpoint

import { appendAmplitudeDeviceId } from "./amplitudeHelper";

const getOrigin = () => window.location.origin;
const getReturnToUri = () => window.location.href.split(getOrigin())[1];

// TODO: set up e2e tests to enforce returnToUrl (ex: on topic page, login, must return to same topic page)
export const returnToUrlClickHandler = (event, relativePath) => {
  event.preventDefault();
  if (typeof window !== "undefined") {
    const returnToUrl = encodeURIComponent(window.location.href);
    // ex: window.location.assign(`/login?returnToUrl=${returnToUrl}`);
    const paramStart = relativePath.includes("?") ? "&" : "?";
    const url = appendAmplitudeDeviceId(
      `${relativePath}${paramStart}returnToUrl=${returnToUrl}`
    );
    window.location.assign(url);
  }
};

export const returnToUriClickHandler = (event, absolutePath) => {
  event.preventDefault();
  if (typeof window !== "undefined") {
    const returnToUrl = encodeURIComponent(getReturnToUri());
    // ex: window.location.assign(
    // `https://dmp.eis-deliverydevqa.cloud/auth-redirect?toInterfaceId=dcd&destinationUri=%2Frecentpage%3Dtrue&returnToUri=${returnToUrl}`);
    const paramStart = absolutePath.includes("?") ? "&" : "?";
    const url = appendAmplitudeDeviceId(
      `${absolutePath}${paramStart}returnToUri=${returnToUrl}`
    );
    window.location.assign(url);
  }
};

/**
 * Handles appending a returnToUrl query param to a given url
 *
 * @param {*} url
 */
export const appendReturnToUrl = (url) => {
  if (typeof window !== "undefined" && url) {
    const separator = url.includes("?") ? "&" : "?";
    const returnToUrl = encodeURIComponent(window.location.href);
    return `${url}${separator}returnToUrl=${returnToUrl}`;
  } else {
    return url;
  }
};
